<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="4"
        md="6"
      >
        <UserCard />
      </b-col>
      <b-col
        xl="8"
        md="6"
      >
        <DepositByAccountType />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="12"
        md="12"
      >
        <LoanPortfolioSummary />
      </b-col>
    </b-row>
    <!-- <b-row class="match-height">
      <b-col
        lg="4"
        md="4"
        cols="6"
      >
        <PendingLoanRequest />
      </b-col>
      <b-col
        lg="4"
        md="4"
        cols="6"
      >
        <NPLRatio :data="data.statisticsProfit" />
      </b-col>
      <b-col
        lg="4"
        md="4"
        cols="6"
      >
        <DashboardAssetQualityRatio />
      </b-col>
      <b-col
        lg="4"
        md="4"
        cols="6"
      >
        <DashboardSavingsRatio />
      </b-col>
      <b-col
        lg="4"
        md="4"
        cols="6"
      >
        <MicroLoanAssetRatio />
      </b-col>
    </b-row> -->

    <b-row class="match-height">
      <b-col lg="5">
        <b-row>
          <b-col
            lg="7"
            md="7"
            cols="6"
          >
            <PendingLoanRequest />
          </b-col>
          <b-col
            lg="5"
            md="5"
            cols="6"
          >
            <NPLRatio :data="data.statisticsProfit" />
          </b-col>
        </b-row>
        <RecentActivities />
      </b-col>

      <!-- Revenue Report Card -->
      <b-col lg="7">
        <!-- <PerformanceReport /> -->
        <CustomerGrowthAnalytics />
      </b-col>
      <!--/ Revenue Report Card -->
    </b-row>

    <b-row class="match-height">
      <!-- Company Table Card -->
      <b-col lg="6">
        <LoggedInUsers />
      </b-col>

      <b-col lg="6">
        <Reports />
      </b-col>

      <!-- Account By Status -->
      <b-col
        lg="4"
        md="6"
      >
        <AccountByStatus />
      </b-col>
      <!--/ Account By Status -->

      <!-- Customer By Gender -->
      <b-col
        lg="4"
        md="6"
      >
        <CustomerByGender />

      </b-col>
      <!--/ Customer By Gender -->

      <!-- Loan Portfolio Risk Summary -->
      <b-col
        lg="4"
        md="6"
      >
        <LoanPortfolioRiskSummary />
      </b-col>
      <!--/ Loan Portfolio Risk Summary -->

      <!-- PAR Formulae Summary -->
      <b-col lg="12">
        <PARFormulaeSummary />
      </b-col>
      <!--/ PAR Formulae Summary -->
      <b-col
        lg="12"
        md="12"
      >
        <AssetQualityRatio />
      </b-col>

      <!-- Get Top Depositors -->
      <b-col lg="6">
        <GetTopDepositors />
      </b-col>
      <!--/ Get Top Depositors -->

      <!-- Get Top Risk Exposures -->
      <b-col lg="6">
        <GetTopRiskExposures />
      </b-col>
      <!--/ Get Top Risk Exposures -->

      <!-- Dashboard Regulatory Compliance -->
      <b-col lg="6">
        <GetDashboardRegulatoryCompliance />
      </b-col>
      <!--/ Dashboard Regulatory Compliance -->
    </b-row>
    <!-- <b-row class="match-height">
      <b-col
        lg="4"
        md="6"
      >
        <CustomerDepositors />
      </b-col>
      <b-col
        lg="4"
        md="6"
      >
        <CustomerExposures />
      </b-col>
      <b-col
        lg="4"
        md="6"
      >
        <LiquidityRatio />
      </b-col>
      <b-col
        lg="4"
        md="6"
      >
        <TreasuryBillsCompliance />
      </b-col>
      <b-col
        lg="4"
        md="6"
      >
        <CapitalAdequacyRatio />
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col
        lg="6"
        md="6"
      >
        <AssetQualityRatio />
      </b-col>
      <b-col
        lg="6"
        md="6"
      >
        <EarningCapacityRatio />
      </b-col>
    </b-row> -->
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { useActions } from 'vuex-composition-helpers'
import { onMounted } from '@vue/composition-api'
// import { getUserData } from '@/auth/utils'
import UserCard from './UserCard.vue'
import LoanPortfolioSummary from './LoanPortfolioSummary.vue'
// import PerformanceReport from './PerformanceReport.vue'
import PendingLoanRequest from './PendingLoanRequest.vue'
import NPLRatio from './NPLRatio.vue'
import DepositByAccountType from './DepositByAccountType.vue'
import LoggedInUsers from './LoggedInUsers.vue'
import RecentActivities from './RecentActivities.vue'
import AccountByStatus from './AccountByStatus.vue'
import CustomerByGender from './CustomerByGender.vue'
import LoanPortfolioRiskSummary from './LoanPortfolioRiskSummary.vue'
import CustomerGrowthAnalytics from './CustomerGrowthAnalytics.vue'
import Reports from './Reports.vue'
import PARFormulaeSummary from './PARFormulaeSummary.vue'
import GetTopDepositors from './GetTopDepositors.vue'
import GetTopRiskExposures from './GetTopRiskExposures.vue'
import GetDashboardRegulatoryCompliance from './GetDashboardRegulatoryCompliance.vue'

import AssetQualityRatio from './AssetQualityRatio.vue'

// import DashboardAssetQualityRatio from './DashboardAssetQualityRatio.vue'
// import DashboardSavingsRatio from './DashboardSavingsRatio.vue'
// import MicroLoanAssetRatio from './MicroLoanAssetRatio.vue'

// import CustomerDepositors from './TopTenCustomerDepositors.vue'
// import CustomerExposures from './TopTenCustomerExposures.vue'
// import LiquidityRatio from './LiquidityRatio.vue'
// import TreasuryBillsCompliance from './TreasuryBillsCompliance.vue'
// import CapitalAdequacyRatio from './CapitalAdequacyRatio.vue'
// import EarningCapacityRatio from './EarningCapacityRatio.vue'
import { dashboardPermissions } from '../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,
    UserCard,
    LoanPortfolioSummary,
    // PerformanceReport,
    CustomerGrowthAnalytics,
    PendingLoanRequest,
    NPLRatio,
    DepositByAccountType,
    LoggedInUsers,
    RecentActivities,
    AccountByStatus,
    CustomerByGender,
    LoanPortfolioRiskSummary,
    Reports,
    PARFormulaeSummary,
    GetTopDepositors,
    GetTopRiskExposures,
    GetDashboardRegulatoryCompliance,
    AssetQualityRatio,

    // DashboardAssetQualityRatio,
    // DashboardSavingsRatio,
    // MicroLoanAssetRatio,
    // CustomerDepositors,
    // CustomerExposures,
    // LiquidityRatio,
    // TreasuryBillsCompliance,
    // CapitalAdequacyRatio,
    // EarningCapacityRatio,
  },
  setup() {
    const {
      getTillAccountList,
      getVaultAccountList,
      getBranches,
      getBanks,
      getIncomeGLAccount,
      getIncomeGLByParentCategory,
      getStationaryAccount,
      getCorporateInformation,
    } = useActions({
      getTillAccountList: 'operations/getTillAccountList',
      getVaultAccountList: 'operations/getVaultAccountList',
      getBranches: 'operations/getAllBranches',
      getBanks: 'operations/getBanks',
      getIncomeGLAccount: 'account/getIncomeGLAccount',
      getIncomeGLByParentCategory: 'account/getIncomeGLByParentCategory',
      getStationaryAccount: 'account/getStationaryAccount',
      getCorporateInformation: 'operations/getCorporateInformationList',
    })

    const fetchData = async () => {
      await getCorporateInformation({ permission: dashboardPermissions.VIEW_EXECUTIVE_DASHBOARD })
      await getVaultAccountList({ search: '', permission: 'VIEW_EXECUTIVE_DASHBOARD' })
      await getTillAccountList({ search: '', permission: 'VIEW_EXECUTIVE_DASHBOARD' })
      await getBanks({ permission: 'VIEW_EXECUTIVE_DASHBOARD' })
      await getBranches({
        search: '',
        page: 0,
        limit: 0,
        permission: 'VIEW_EXECUTIVE_DASHBOARD',
      })
      await getIncomeGLAccount({ permission: 'VIEW_EXECUTIVE_DASHBOARD' })
      await getIncomeGLByParentCategory({ permission: 'VIEW_EXECUTIVE_DASHBOARD' })
      await getStationaryAccount({ permission: 'VIEW_EXECUTIVE_DASHBOARD' })
    }

    onMounted(async () => {
      await fetchData()
    })
  },
  data() {
    return {
      data: {},
    }
  },
  // created() {
  //   // data
  //   const userData = getUserData()
  //   this.data.congratulations.name = userData ? (userData.firstname || userData.username) : null
  // },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
